import { stateEventService } from './state-event-service';

class StateEventObjectVirtual {
	/**
	 * registers to StateEventService
	 * @constructor singleton
	 */
	constructor() {
		if (StateEventObjectVirtual._instance) {
			return StateEventObjectVirtual._instance;
		}

		stateEventService.register(StateEventObjectVirtual.getData);

		StateEventObjectVirtual._instance = this;
	}

	/**
	 * getData - collects the tracking data
	 * @param {String} eventType_ - event typ
	 * @returns {Promise} promise - returns promise for stateEventObject
	 */
	static async getData(eventType_) {
		if (
			eventType_ !== 'PAGE_READY' &&
			eventType_ !== 'LAYER_LOADED' &&
			eventType_ !== 'LAYER_CLOSED'
		) {
			return {};
		}

		let eventObject = {
			eventInfo: {
				eventAction: 'step',
				eventName: 'generic',
			},
			attributes: {
				componentName: '',
				label: '',
				currentURL: window.location.href,
				targetURL: '',
				clickID: '',
				elementName: '',
				value: '',
				pos: '',
			},
		};

		return eventObject;
	}
}

/**
 * Singleton instance
 * @type {StateEventObjectVirtual}
 * @private
 * @static
 */

const stateEventObjectVirtual = new StateEventObjectVirtual();

export { stateEventObjectVirtual, StateEventObjectVirtual };
